import { createTheme } from '@material-ui/core';
import { THDButtonStyles } from './button';
import { THDIconButtonStyles } from './icon-button';
import { THDCheckboxStyles } from './checkbox';
import { THDFormControlLabelStyles } from './form-control-label';
import { THDFormControlStyles } from './form-control';
import { THDFormGroupStyles } from './form-group';
import { THDFormHelperTextStyles } from './form-helper-text';
import { THDRadioStyles } from './radio';
import { THDSelectStyles } from './select';
import { THDInputStyles } from './input';
import { THDInputBaseStyles } from './input-base';
import { THDInputAdornmentStyles } from './input-adornment';
import { THDInputLabelStyles } from './input-label';
import { THDFormLabelStyles } from './form-label';
import { THDDatePickerStyles } from './datepicker';
import { THDSvgIconStyles } from './svg-icon';
import { THDTypographyStyles } from './typography';
import { THDMenuItemStyles } from './menu-item';
import { THDAlertStyles } from './alert';
import { THDLinkStyles } from './link';
export var THDTheme = createTheme({
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
        MuiSelect: {
            MenuProps: {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                getContentAnchorEl: null,
            },
            disableUnderline: true,
        },
        MuiInputLabel: {
            shrink: true,
        },
        MuiInput: {
            disableUnderline: true,
        },
        MuiLink: {
            underline: 'always',
        },
    },
    typography: THDTypographyStyles,
    breakpoints: {
        values: {
            xs: 320,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
        },
    },
    palette: {
        common: {
            black: '#000000',
            white: '#FFFFFF',
        },
        type: 'light',
        primary: {
            main: '#F96302',
            light: '#FDD8C0',
            dark: '#C14C00',
        },
        secondary: {
            // Darken so we reach the AA contrast ratio level.
            main: '#F96302', // darken('#019E84', 0.4),
        },
        error: {
            main: '#E34A4A',
            light: '#FFAFAF',
            dark: '#AB0000',
        },
        warning: {
            main: '#FBC524',
            light: '#FEE9A9',
            dark: '#DDA413',
        },
        info: {
            main: '#62D4CA',
            light: '#B5FFF8',
            dark: '#3B8780',
        },
        success: {
            main: '#1DDB7F',
            light: '#BFE9D4',
            dark: '#009A4F',
        },
        grey: {
            50: '#F4F4F4',
            100: '#E1E1E1',
            200: '#CCCCCB',
            300: '#969695',
            400: '#7A7978',
            500: '#61605F',
            600: '#4B4A4A',
            700: '#373636',
            800: '#212120',
            900: '#121111',
            A100: '#d5d5d5',
            A200: '#aaaaaa',
            A400: '#303030',
            A700: '#616161',
        },
        text: {
            primary: '#212120',
            secondary: '#FFFFFF',
            disabled: '#CCCCCB',
            hint: '#7A7978',
        },
    },
    overrides: {
        MuiButton: THDButtonStyles,
        MuiCheckbox: THDCheckboxStyles,
        MuiFormControlLabel: THDFormControlLabelStyles,
        MuiFormControl: THDFormControlStyles,
        MuiFormGroup: THDFormGroupStyles,
        MuiFormHelperText: THDFormHelperTextStyles,
        MuiFormLabel: THDFormLabelStyles,
        MuiRadio: THDRadioStyles,
        MuiIconButton: THDIconButtonStyles,
        MuiSelect: THDSelectStyles,
        MuiInput: THDInputStyles,
        MuiInputBase: THDInputBaseStyles,
        MuiSvgIcon: THDSvgIconStyles,
        MuiInputAdornment: THDInputAdornmentStyles,
        MuiInputLabel: THDInputLabelStyles,
        MuiMenuItem: THDMenuItemStyles,
        MuiLink: THDLinkStyles,
        // MuiPickersCalendarHeader: THDDatePickerStyles.pickersCalendarHeader,
        // MuiPickersDay: THDDatePickerStyles.pickersDay,
        MuiDialogActions: THDDatePickerStyles.dialogActions,
        // MuiPickersToolbar: THDDatePickerStyles.pickersToolbar,
        MuiPaper: {
            root: {
                '&$rounded': {
                    borderRadius: 2,
                },
            },
        },
        MuiAlert: THDAlertStyles,
    },
});
